<template>
  <span>
    <v-select v-if="displayType === 'form'" :value="selected" @input="changeCallback" :options="disciplineList" multiple label="name" value-prop="id"></v-select>
    <span v-if="displayType === 'label'">{{disciplineLabel}}</span>
  </span>
</template>

<script>
  import CommonDataService from '../endpoints/CommonDataService'
  import vSelect from './SelectComponent.vue'

  export default {
    emits: ['update:modelValue','change'],
    name: 'discipline-multi-input',
    components: {vSelect},

    props: {
      modelValue: {
        type: Array,
        default: () => []
      },
      displayType: {
        type: String,
        default: 'form'
      },
      sportCode: {
        type: String,
        required: false
      },
      showUpdates: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        disciplineList: [],
        selected: []
      }
    },
    watch: {
      modelValue: {
        handler: function (val) {
          if (val && Array.isArray(val) && this.disciplineList.length > 0) {
            this.selected = val
              .filter(item => item.actionCode !== 'D')
              .map(item => this.disciplineList.find(d => d.id === item.disciplineId))
              .filter(discipline => discipline !== undefined)
          } else {
            this.selected = []
          }
        },
        immediate: true,
        deep: true
      },
      disciplineList: function (val) {
        // Re-sync selected when disciplineList loads
        if (this.modelValue && Array.isArray(this.modelValue) && val.length > 0) {
          this.selected = this.modelValue
            .filter(item => item.actionCode !== 'D')
            .map(item => val.find(d => d.id === item.disciplineId))
            .filter(discipline => discipline !== undefined)
        }
      },
      sportCode: function (val) {
        this.loadDisciplineList()
      }
    },
    computed: {
      disciplineLabel: function () {
        let label = ''
        const self = this
        if (this.disciplineList && this.disciplineList.length > 0 && this.modelValue && Array.isArray(this.modelValue)) {
          for (let i = 0; i < this.modelValue.length; i++) {
            const item = self.value[i]

            // Filter based on showUpdates flag
            if (!self.showUpdates && item.actionCode === 'A') {
              continue
            }
            if (self.showUpdates && item.actionCode === 'D') {
              continue
            }

            let discipline = self.disciplineList.find((el) => el.id === item.disciplineId)
            if (discipline) {
              if (label.length > 0) {
                label += '; '
              }
              label += discipline.name
            }
          }
          return label
        }

        return ''
      }
    },
    methods: {
      loadDisciplineList: function () {
        // Don't load if sportCode is null or blank
        if (!this.sportCode || this.sportCode.trim() === '') {
          this.disciplineList = []
          return
        }

        let self = this

        CommonDataService.loadDisciplinesBySport(this.sportCode)
          .then(response => {
            self.disciplineList = response.data
          })
          .catch(error => {
            self.error = error.message
          })
      },
      changeCallback (val) {
        /// val is an array of discipline IDs currently selected in v-select
        const currentValue = this.modelValue && Array.isArray(this.modelValue) ? this.modelValue : []

        // Extract IDs from val array (which contains discipline objects)
        const selectedIds = val.map(discipline => discipline.id)

        // Get IDs of currently selected items (excluding deleted ones)
        const currentSelectedIds = currentValue
          .filter(item => item.actionCode !== 'D')
          .map(item => item.disciplineId)

        // Determine which items were added and which were removed
        const addedIds = selectedIds.filter(id => !currentSelectedIds.includes(id))
        const removedIds = currentSelectedIds.filter(id => !selectedIds.includes(id))

        // Build the updated value array
        const updatedValue = currentValue.map(item => {
          if (removedIds.includes(item.disciplineId)) {
            // Mark removed items for deletion
            return {
              ...item,
              actionCode: 'D'
            }
          } else if (addedIds.includes(item.disciplineId) && item.actionCode === 'D') {
            // Re-adding a previously deleted item - change actionCode back to 'N'
            // Also update the discipline object from val
            const discipline = val.find(d => d.id === item.disciplineId)
            return {
              ...item,
              actionCode: 'N',
              discipline: discipline ? { id: discipline.id, name: discipline.name } : item.discipline
            }
          } else if (item.actionCode !== 'D') {
            // Keep existing items with their current actionCode (N or A)
            // Update discipline object if available in val
            const discipline = val.find(d => d.id === item.disciplineId)
            return {
              ...item,
              discipline: discipline ? { id: discipline.id, name: discipline.name } : item.discipline
            }
          } else {
            // Item was previously deleted, keep it deleted
            return item
          }
        })

        // Add newly selected items
        addedIds.forEach(disciplineId => {
          const existsInCurrent = currentValue.some(item => item.disciplineId === disciplineId)
          if (!existsInCurrent) {
            const discipline = val.find(d => d.id === disciplineId)
            updatedValue.push({
              id: null,
              actionCode: 'A',
              disciplineId: disciplineId,
              discipline: discipline ? { id: discipline.id, name: discipline.name } : null
            })
          }
        })

        this.$emit('update:modelValue', updatedValue)
        this.$emit('change', updatedValue)
      }
    },
    created () {
      this.loadDisciplineList()
    }
  }
</script>
